const allowedSymbols = /^[0-9a-zA-Z_-]+$/;

export default alias => !alias || allowedSymbols.test(alias);



// WEBPACK FOOTER //
// ./src/utils/validations/aliasNameFormatValidator.js